import type { FC } from 'react';
import { CALL_TO_ACTION } from '../../constants';
import Select, { type SelectProps } from './Select';

interface Platform {
  name: string;
  code: string | number; // Adjust the type based on your actual data
}

type SelectPlatformProps = Partial<Pick<SelectProps, 'handleChange' | 'name' | 'inputLabel' | 'required'>>;

const SelectCallToAction: FC<SelectPlatformProps> =
  ({
     handleChange,
     name,
     inputLabel,
     required,
   }) => {
    const listMapper = ({ name, code }: Platform) => ({
      label: name,
      value: code,
    });

    return (
      <Select
        name={name ?? 'callToAction'}
        inputLabel={inputLabel ?? 'Call To Action'}
        options={CALL_TO_ACTION.map(listMapper)}
        handleChange={handleChange}
        required={required}
      />
    );
  };

export default SelectCallToAction;